'use client'

import { ReactNode } from 'react'

import {
  AddToCartButton,
  ReplaceCartItemButton,
  useDisplayCart
} from 'modules/cart'
import { ProductPorts, ProductPortsProvider } from 'modules/products'
import { SpecialPromotion } from 'modules/promotions'

const useCartCouponCode = () => {
  const cart = useDisplayCart()

  return cart?.discountCodes[0]?.code || undefined
}

const productAdapters: ProductPorts = {
  ProductActionButton: AddToCartButton,
  SpecialPromotion,
  ProductReplaceButton: ReplaceCartItemButton,
  useCartCouponCode
}

export const ProductAdaptersProvider = ({ children }: { children: ReactNode }) => (
  <ProductPortsProvider ports={productAdapters}>
    {children}
  </ProductPortsProvider>
)
